export enum BankReportHistoryType {
    Status = 0,
    PromissoryNote = 1,
    Change = 2
}
